import React, { useState } from "react";
import { Spring, easings, animated } from "react-spring";
import { Waypoint } from "react-waypoint";

interface Props {
  children: React.ReactNode;
  disabled?: boolean;
}

const Fade: React.FC<Props> = ({ children, disabled = false }) => {
  const [fadeIn, setFadeIn] = useState(false);

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <>
      <Waypoint
        topOffset={"20%"}
        onEnter={() => setFadeIn(true)}
        onLeave={() => setFadeIn(false)}
      />
      <Spring
        from={{
          opacity: fadeIn ? 0 : 1,
        }}
        to={{ opacity: fadeIn ? 1 : 0 }}
        config={{ duration: 1400, easing: easings.easeOutSine }}
      >
        {(animatedStyles) => {
          return <animated.div style={animatedStyles}>{children}</animated.div>;
        }}
      </Spring>
    </>
  );
};

export { Fade };
